import React from "react";
import { useIntl } from "react-intl";
import { TableCell } from "@material-ui/core";

const RelatedProtocolVisibleTableCell = ({ protocol }) => {
  const intl = useIntl();

  return (
    <TableCell>
      {intl.formatMessage({
        id: `app.sg.details.relatedProtocols.hidden.${protocol.hideFromPatient}`,
      })}
    </TableCell>
  );
};

export default RelatedProtocolVisibleTableCell;
